import React, {Component} from "react"
import styled from "styled-components"
import {Row, Col, Grid} from "react-bootstrap"

import {List as ListBase, Item, LoadMore, NoResults} from "@irati-web/reward/src/components/List"
import Tile from "@irati-web/reward/src/components/Tile"
import Loader from "@irati/utils/services/apollo/Loading/Loader"
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom"
import {AllRewardsRouteProps} from "@irati-web/reward/src/types"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/Feed"
import padding from "@irati/ui/src/global/padding"
import RewardsQueryComponent, {RewardsData} from "@irati/reward/apollo/query/Rewards"
import {RewardStatus} from "@irati/reward/enums"
import CustomTile from "@irati-web/reward/src/components/CustomReward/Tile"
import {rewardTracking} from "@irati-tracking/reward"

import Layout from "@irati-web/recognition/src/components/Layout"

const List = styled(ListBase)`
  margin-top: ${padding.large};
`

interface State {
  hasRefetchingError: boolean
}

interface FetchMore {
  (): Promise<any>
}

export default class RecognitionAllRewards extends Component<AllRewardsRouteProps, State> {
  state = {
    hasRefetchingError: false
  }

  onLoadMore: FetchMore | null = null

  componentDidMount() {
    window.addEventListener("online", this.handleNetworkStatusChange)
    window.addEventListener("scroll", this.handleScroll)
    rewardTracking.rewardsTabViewAllRewards()
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.handleNetworkStatusChange)
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const atBottom = scrollAtBottom()
    const {hasRefetchingError} = this.state

    if (atBottom && !hasRefetchingError) {
      this.fetchMore()
    }
  }

  handleNetworkStatusChange = () => {
    const {hasRefetchingError} = this.state

    if (navigator.onLine && hasRefetchingError) {
      this.fetchMore()
    }
  }

  fetchMore = () => {
    if (this.onLoadMore) {
      this.setState({
        hasRefetchingError: false
      })
      this.onLoadMore().catch(() => {
        this.setState({
          hasRefetchingError: true
        })
      })
    }
  }

  hasReceivedData(data?: RewardsData) {
    return (
      data && "rewardCatalogueRewards" in data && "results" in data.rewardCatalogueRewards && data.rewardCatalogueRewards.results.length > 0
    )
  }

  render() {
    const {hasRefetchingError} = this.state
    const params = {
      limit: 12,
      status: RewardStatus.ON,
      sortBy: "createdAt",
      sortDir: "DESC",
      rewardsForMyPackage: true
    }

    return (
      <Layout>
        <Grid>
          <Row>
            <Col xs={12}>
              <DisablePointerEventsOnScroll>
                <List>
                  <RewardsQueryComponent useLoader={false} variables={params}>
                    {({data, onLoadMore, refetch, loading: isLoading, error, networkStatus}) => {
                      const hasData = this.hasReceivedData(data)
                      const hasError = error || hasRefetchingError
                      const isRefetching = networkStatus === 3

                      this.onLoadMore = !isLoading ? () => onLoadMore() : null

                      return isLoading && !isRefetching ? (
                        <Loader />
                      ) : (
                        <>
                          {data && hasData && (
                            <>
                              <Item>
                                <CustomTile />
                              </Item>
                              {data.rewardCatalogueRewards.results.map((reward) => (
                                <Item key={reward.uuid}>
                                  <Tile id={`tile-${reward.uuid}`} reward={reward} />
                                </Item>
                              ))}
                            </>
                          )}
                          {isLoading && <Loader />}
                          {!isLoading && hasError && <LoadMore onClick={error ? () => refetch() : this.fetchMore} />}
                          {!isLoading && !hasError && !hasData && <NoResults />}
                        </>
                      )
                    }}
                  </RewardsQueryComponent>
                </List>
              </DisablePointerEventsOnScroll>
            </Col>
          </Row>
        </Grid>
      </Layout>
    )
  }
}
